import React from "react";
import OrganisationMaster from "./OrganisationMaster";
import { labels } from "../../../../../localization/labels";
import { paths } from "../../../../paths";
import TableUtils from "../../../../core/Table/TableUtils";
import { withRouter } from "react-router-dom";
import PathUtil from "../../../../../utils/PathUtil";
import { withKeycloak } from "@react-keycloak/web";
import OrganisationService from "../../../../../services/OrganisationService";
import TableComponentWithDialog from "../../../page/TableComponentWithDialog";
import { Comparator } from "react-bootstrap-table2-filter";
import {
  organisationValidationRules as validationRules,
  validateEntity
} from "../../../../../validators/validationRules";

class OrganisationMasterContainer extends TableComponentWithDialog {
  constructor(props) {
    super(props);
    this.organisationService = new OrganisationService(this.keycloak);
  }

  initialSortInfo() {
    return {
      orderBy: "name",
      direction: "asc"
    };
  }

  resetEntity = () => {
    return {
      name: null,
      noDescription: true,
      noDateRange: true,
      noName: true
    };
  };

  getComponentTitle = () => {
    return undefined;
  };

  loadData = pageInfo => {
    this.prepareCall(
      this.organisationService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onDataLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  columns = this.initColumns([
    {
      dataField: "id",
      text: labels.id,
      sort: true,
      classes: "column-id",
      headerClasses: "column-header-id-filtered",
      headerFormatter: this.formatHeader,
      filter: TableUtils.textFilter(labels.id, Comparator.EQ)
    },
    {
      dataField: "name",
      text: labels.name,
      sort: true,
      formatter: TableUtils.textFormatter,
      headerClasses: "column-header-filtered",
      headerFormatter: this.formatHeader,
      filter: TableUtils.textFilter(labels.name)
    }
  ]);

  onRowClick = (_, row) => {
    const itemPath = PathUtil.adminItemPath(`${paths.ORGANISATIONS}`, row.id);
    this.changePath(itemPath, row.name);
  };

  onCreateData = entity => {
    this.prepareCall(
      this.organisationService.postEntity(
        entity.name,
        this.onDataSaveResponse,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onDataSaveResponse = data => {
    const itemPath = PathUtil.adminItemPath(paths.ORGANISATIONS, data.id);
    this.handleClose();
    this.changePath(itemPath, data.name);
  };

  onDeleteData = type => {
    this.prepareCall(
      this.organisationService.deleteEntity(
        type,
        this.onDataDeleteResponse,
        this.onDeleteSuccessMessage,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  validator = entity => {
    return validateEntity(entity, validationRules.generalDataName);
  };

  inputFields = () => [
    {
      label: labels.name,
      controlId: "name",
      placeholder: labels.name,
      type: "text"
    }
  ];

  render() {
    return (
      <OrganisationMaster
        {...this.renderProps()}
        onRowClick={this.onRowClick}
        tableLabel={this.props.tableLabel}
        disabled={this.state.disabled}
        inputFields={this.inputFields()}
        validationRules={validationRules.generalDataName}
      />
    );
  }
}

export default withKeycloak(withRouter(OrganisationMasterContainer));
